import { Injectable } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService } from './auth.service';

/**
 * #deprecated
 * In Angular 16+, CanActivate, CanDeactivate, etc. are technically deprecated, but they still work just fine.
 * will move to functional guards in angular 18 migration
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  constructor(private auth: AuthService, private navCtrl: NavController) {}

  canActivate: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const authStatus = await this.auth.isUserAuthenticated();

    switch (authStatus) {
      case 'LOGGED_IN':
        return true;
      case 'LOGGED_OUT':
        this.navCtrl.navigateRoot(['/login']);
        return true;
      default:
        return false;
    }
  };
}
